<template>
  <div class="sidebar-shell">
    <aside
      class="flowbite-sidebar"
      :class="{ 'is-collapsed': collapsed }"
      aria-label="Sidebar"
    >
      <div class="sidebar-surface">
        <div class="sidebar-top">
          <button
            type="button"
            class="sidebar-brand"
            :class="{ 'is-collapsed': collapsed }"
            :title="collapsed ? 'Dashboard' : ''"
          >
            <!--img
              src="@/assets/images/main-logo01.png"
              alt="Logo"
              class="sidebar-brand-logo"
            /-->
            <span v-if="!collapsed" class="sidebar-brand-text text-uppercase">
              {{ menuName || "Gestion Commerciale" }}
            </span>
            <div>

                <button
                type="button"
                class="sidebar-collapse-btn d-none d-md-inline-flex"
                :class="{ 'is-collapsed': collapsed }"
                @click="toggleSidebar"
                :aria-label="collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
              >
                <i class="fas" :class="collapsed ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
              </button>
            </div>


          </button>

 
        </div>

        <nav class="sidebar-nav">
          <template v-for="(item, index) in rawMenu">
            <div
              v-if="item.type === 'header'"
              :key="`header-${index}`"
              class="sidebar-section-title"
              :class="{ 'is-collapsed': collapsed }"
            >
              {{ item.isCampaignName ? menuName : $t(item.title) }}
            </div>

            <div
              v-else-if="item.child && item.child.length"
              :key="`group-${index}`"
              class="sidebar-group"
            >
              <button
                type="button"
                class="sidebar-item sidebar-item-parent"
                :class="{
                  active: isParentActive(item),
                  open: isSectionOpen(itemKey(item, index))
                }"
                :title="collapsed ? item.name : ''"
                @click="toggleSection(itemKey(item, index))"
              >
                <span class="sidebar-item-content">
                  <span class="sidebar-icon">
                    <i :class="item.icon"></i>
                  </span>
                  <span v-if="!collapsed" class="sidebar-label">{{ item.name }}</span>
                </span>
                <i
                  v-if="!collapsed"
                  class="fas sidebar-chevron"
                  :class="isSectionOpen(itemKey(item, index)) ? 'fa-chevron-up' : 'fa-chevron-down'"
                ></i>
              </button>

              <transition name="sidebar-submenu">
                <ul
                  v-show="!collapsed && isSectionOpen(itemKey(item, index))"
                  class="sidebar-submenu"
                >
                  <li
                    v-for="(child, childIndex) in item.child"
                    :key="`child-${index}-${childIndex}`"
                  >
                    <button
                      type="button"
                      class="sidebar-item sidebar-item-child"
                      :class="{ active: isMenuItemActive(child) }"
                      :title="collapsed ? child.name : ''"
                      @click="handleDesktopItemClick(child)"
                    >
                      <span class="sidebar-item-content">
                        <span class="sidebar-icon sidebar-icon-child">
                          <i :class="child.icon"></i>
                        </span>
                        <span class="sidebar-label">{{ child.name }}</span>
                      </span>
                    </button>
                  </li>
                </ul>
              </transition>
            </div>

            <button
              v-else
              :key="`item-${index}`"
              type="button"
              class="sidebar-item sidebar-item-link"
              :class="{ active: isMenuItemActive(item) }"
              :title="collapsed ? item.name : ''"
              @click="handleDesktopItemClick(item)"
            >
              <span class="sidebar-item-content">
                <span class="sidebar-icon">
                  <i :class="item.icon"></i>
                </span>
                <span v-if="!collapsed" class="sidebar-label">{{ item.name }}</span>
              </span>
            </button>
          </template>
        </nav>

        <div v-if="!collapsed" class="sidebar-footer">
          <div class="sidebar-footer-card">
            <div class="sidebar-footer-avatar">
              {{ userInitials }}
            </div>
            <div class="sidebar-footer-text">
              <strong>{{ userFullName || "Utilisateur" }}</strong>
              <span>Connecté</span>
            </div>
          </div>
        </div>
      </div>
    </aside>

    <nav :class="['mobile-bottom-bar', { 'is-compact': bottomNavItems.length < 5 }]" aria-label="Navigation mobile">
      <button
        v-for="item in bottomNavItems"
        :key="item.key"
        type="button"
        class="mobile-bottom-item"
        :class="{ active: isBottomNavActive(item), primary: item.key === 'menu' }"
        :aria-label="item.label"
        @click="onBottomNavClick(item)"
      >
        <span class="bottom-icon">
          <i :class="item.icon"></i>
        </span>
        <span class="bottom-label">{{ item.label }}</span>
      </button>
    </nav>

    <b-modal
      v-model="showMobileMenu"
      hide-header
      hide-footer
      centered
      modal-class="mobile-menu-bottom-sheet"
      content-class="mobile-menu-sheet-content"
      body-class="p-0 mobile-menu-body"
    >
      <div class="mobile-sheet-handle" aria-hidden="true"></div>
      <div class="mobile-sheet-intro">
        <div>
          <span class="mobile-sheet-eyebrow">Votre espace</span>
          <strong>Menu</strong>
        </div>
        <button
          class="mobile-sheet-close"
          type="button"
          aria-label="Fermer le menu"
          @click="showMobileMenu = false"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="mobile-menu-list">
        <section
          v-for="(section, sectionIndex) in mobileMenuSections"
          :key="`mobile-section-${sectionIndex}`"
          class="mobile-menu-section-card"
        >
          <div class="mobile-section-heading">
            <span class="mobile-group-icon">
              <i :class="section.icon"></i>
            </span>
            <strong>{{ section.label }}</strong>
          </div>

          <div class="mobile-section-grid">
            <template v-for="(item, index) in section.items">
          <div
            v-if="item.child && item.child.length"
            :key="`mobile-group-${index}`"
            class="mobile-menu-group"
          >
            <div class="mobile-group-heading">
              <span class="mobile-group-icon">
                <i :class="item.icon"></i>
              </span>
              <div>
                <strong>{{ item.name }}</strong>
              </div>
            </div>

            <div class="mobile-submenu">
              <button
                v-for="(child, childIndex) in item.child"
                :key="`mobile-child-${index}-${childIndex}`"
                type="button"
                class="mobile-menu-item mobile-menu-item-child"
                :class="{ active: isMobileMenuItemActive(child) }"
                @click="onMobileMenuSelect(child)"
              >
                <span class="mobile-item-left">
                  <span class="mobile-card-icon mobile-card-icon-child">
                    <i :class="child.icon"></i>
                  </span>
                  <span>{{ child.name }}</span>
                </span>
              </button>
            </div>
          </div>

          <button
            v-else
            :key="`mobile-leaf-${index}`"
            type="button"
            class="mobile-menu-item"
            :class="{ active: isMobileMenuItemActive(item) }"
            @click="onMobileMenuSelect(item)"
          >
            <span class="mobile-item-left">
              <span class="mobile-card-icon">
                <i :class="item.icon"></i>
              </span>
              <span>{{ item.name }}</span>
            </span>
          </button>
            </template>
          </div>
        </section>
      </div>

      <div v-if="showApkDownloadButton" class="mobile-apk-download">
        <a class="mobile-apk-download-btn" href="/api/app/android-apk" download>
          <span class="mobile-apk-icon">
            <i class="fas fa-download"></i>
          </span>
          <span>
            <strong>Télécharger l'application</strong>
            <small>Installer APK Android</small>
          </span>
        </a>
      </div>

    </b-modal>
  </div>
</template>

<script>
import { menuItemsByPrivileges } from "@/utils/menus.js";
import { addDraftInvoice } from "@/services/invoice-api";
import { addDraftPurchaseInvoice } from "@/services/purchasingInvoice-api";
import { addDraftOrder } from "@/services/order-api";
import Swal from "sweetalert2";
import { getSupplier } from "@/services/supplier-api";
import { Capacitor } from "@capacitor/core";
import { hasExactRole, ROLES } from "@/utils/permissions";

export default {
  props: { collapsed: { type: Boolean } },
  emits: ["update:collapsed"],
  data() {
    return {
      userFullName: this.getCookie("ufn")
        ? decodeURIComponent(this.getCookie("ufn"))
        : null,
      showMobileMenu: false,
      mobileOpenSections: {},
      openSections: {},
      menuName: "",
      isMobileBrowser: false,
    };
  },
  computed: {
    userInitials() {
      const value = (this.userFullName || "Utilisateur").trim();
      const parts = value.split(/\s+/).filter(Boolean);
      if (!parts.length) return "U";
      return parts
        .slice(0, 2)
        .map((part) => part.charAt(0).toUpperCase())
        .join("");
    },
    showApkDownloadButton() {
      return this.isMobileBrowser && !Capacitor.isNativePlatform();
    },
    bottomNavItems() {
      if (this.isAccountantOnlyUser()) {
        const documentItems = this.flattenMenuItems(this.rawMenu)
          .filter((item) => ["/document/invoice", "/document/credit-note"].includes(item.path))
          .map((item) => ({
            key: item.path,
            label: item.path === "/document/invoice" ? "Facture" : "Avoir",
            icon: item.icon,
            path: item.path,
          }));

        return [
          ...documentItems.slice(0, 1),
          { key: "menu", label: "Menu", icon: "fas fa-bars" },
          ...documentItems.slice(1),
        ];
      }

      return [
        { key: "dashboard", label: "Dashboard", icon: "fas fa-tachometer-alt", path: "/dashboard" },
        { key: "invoice", label: "Facture", icon: "fas fa-file-invoice-dollar", path: "/document/invoice" },
        { key: "menu", label: "Menu", icon: "fas fa-bars" },
        { key: "quote", label: "Devis", icon: "fas fa-list", path: "/document/quote" },
        { key: "customer", label: "Client", icon: "fas fa-user-tie", path: "/users/customer" },
      ];
    },
    rawMenu() {
      return menuItemsByPrivileges(
        this.$store.getters.catalogEnabled,
        this.$store.getters.stockEnabled,
        this.$store.getters.purchaseEnabled,
        this.$store.getters.expenseEnabled,
        this.$store.getters.employeeEnabled,
        this.$store.getters.notificationEnabled,
        this.$store.getters.reportEnabled
      );
    },
    mobileMenuSections() {
      const sectionIcons = {
        Admin: "fas fa-user-shield",
        Analytics: "fas fa-chart-pie",
        Document: "fas fa-file-invoice",
        Catalogue: "fas fa-box-open",
        Stock: "fas fa-warehouse",
        "Clients & Fournisseurs": "fas fa-users",
        Charges: "fas fa-wallet",
        Notifications: "far fa-bell",
        Configuration: "fas fa-sliders-h",
        "Déconnecter": "fas fa-power-off",
      };
      const sections = [];
      let currentSection = null;

      this.rawMenu.forEach((item) => {
        if (item.type === "header") {
          const label = item.isCampaignName ? this.menuName : this.$t(item.title);
          currentSection = {
            key: item.title,
            label,
            icon: sectionIcons[item.title] || "fas fa-th-large",
            items: [],
          };
          sections.push(currentSection);
          return;
        }

        if (!currentSection) {
          currentSection = {
            key: "Menu",
            label: this.$t("Menu"),
            icon: "fas fa-th-large",
            items: [],
          };
          sections.push(currentSection);
        }

        currentSection.items.push(item);
      });

      const contactsSection = sections.find(
        (section) => section.key === "Clients & Fournisseurs"
      );

      if (contactsSection) {
        sections.forEach((section) => {
          if (section === contactsSection) return;

          const partnerItems = section.items.filter(
            (item) => item.name === "Partenaires"
          );
          section.items = section.items.filter(
            (item) => item.name !== "Partenaires"
          );
          contactsSection.items.push(...partnerItems);
        });
      }

      return sections
        .filter((section) => section.items.length)
        .map((section) => {
          if (section.key !== "Document") return section;

          return {
            ...section,
            items: section.items.flatMap((item) =>
              item.child?.length ? item.child : [item]
            ),
          };
        });
    },
  },
  watch: {
    $route() {
      this.showMobileMenu = false;
      this.syncOpenSectionsWithRoute();
    },
    showMobileMenu(isOpen) {
      if (!isOpen) {
        this.mobileOpenSections = {};
      }
    },
    rawMenu: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.syncOpenSectionsWithRoute();
        });
      },
    },
  },
  async mounted() {
    this.isMobileBrowser = this.detectMobileBrowser();

    try {
      const supplier = await getSupplier();
      this.menuName = supplier?.name || "";
      this.$store.commit("SET_CATALOG_ENABLED", supplier?.catalogEnabled);
      this.$store.commit("SET_STOCK_ENABLED", supplier?.stockEnabled);
      this.$store.commit("SET_PURCHASE_ENABLED", supplier?.purchaseEnabled);
      this.$store.commit("SET_EXPENSE_ENABLED", supplier?.expenseEnabled);
      this.$store.commit("SET_EMPLOYEE_ENABLED", supplier?.employeeEnabled);
      this.$store.commit("SET_NOTIFICATION_ENABLED", supplier?.notificationEnabled);
      this.$store.commit("SET_REPORT_ENABLED", supplier?.reportEnabled);
    } catch (error) {
      this.menuName = "";
      this.$store.commit("SET_CATALOG_ENABLED", false);
      this.$store.commit("SET_STOCK_ENABLED", false);
      this.$store.commit("SET_PURCHASE_ENABLED", false);
      this.$store.commit("SET_EXPENSE_ENABLED", false);
      this.$store.commit("SET_EMPLOYEE_ENABLED", false);
      this.$store.commit("SET_NOTIFICATION_ENABLED", false);
      this.$store.commit("SET_REPORT_ENABLED", false);
    } finally {
      this.$nextTick(() => {
        this.syncOpenSectionsWithRoute();
      });
    }
  },
  methods: {
    toggleSidebar() {
      this.$emit("update:collapsed", !this.collapsed);
    },
    goToDashboard() {
      if (this.$route.path !== "/dashboard") {
        this.$router.push("/dashboard").catch(() => {});
      }
    },
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
      return null;
    },
    isAccountantOnlyUser() {
      return (
        hasExactRole(ROLES.ACCOUNTANT) &&
        !hasExactRole(ROLES.SUPPLIER) &&
        !hasExactRole(ROLES.ADMIN)
      );
    },
    flattenMenuItems(items) {
      return items.flatMap((item) => {
        if (!item || item.type === "header") return [];
        if (item.child && item.child.length) return this.flattenMenuItems(item.child);
        return item.path ? [item] : [];
      });
    },
    detectMobileBrowser() {
      if (typeof window === "undefined" || typeof navigator === "undefined") {
        return false;
      }

      const userAgent = navigator.userAgent || navigator.vendor || "";
      const isTouchDevice = window.matchMedia?.("(pointer: coarse)").matches || navigator.maxTouchPoints > 0;
      return isTouchDevice && /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent);
    },
    itemKey(item, fallbackIndex = 0) {
      return item?.path || item?.link || item?.href || item?.name || item?.title || `menu-${fallbackIndex}`;
    },
    isPathActive(path) {
      return !!path && this.$route.path === path;
    },
    isMenuItemActive(item) {
      const itemPath = this.getMenuItemPath(item);
      if (this.isPathActive(itemPath)) {
        return true;
      }

      return !!item?.child?.some((child) => this.isMenuItemActive(child));
    },
    isParentActive(item) {
      return this.isMenuItemActive(item);
    },
    getMenuItemPath(item) {
      return item?.path || item?.link || item?.href || "";
    },
    syncOpenSectionsWithRoute() {
      const nextOpenSections = {};

      this.rawMenu.forEach((item, index) => {
        if (!item?.child?.length) return;

        const key = this.itemKey(item, index);
        if (this.isParentActive(item)) {
          nextOpenSections[key] = true;
        }
      });

      this.openSections = nextOpenSections;
    },
    isSectionOpen(key) {
      return !!this.openSections[key];
    },
    toggleSection(key) {
      this.openSections[key] = !this.openSections[key];
    },
    async handleDesktopItemClick(item) {
      if (item?.child && item.child.length) {
        this.toggleSection(this.itemKey(item));
        return;
      }

      await this.handleItemClick({ preventDefault() {} }, {
        href: item?.link || item?.path || item?.href || "",
        path: item?.path || item?.link || item?.href || "",
        action: item?.action,
      });
    },
    isMobileSectionOpen(index) {
      return !!this.mobileOpenSections[index];
    },
    getMobileMenuPath(item) {
      return item?.path || item?.link || item?.href || "";
    },
    isBottomNavActive(item) {
      if (item.key === "menu") {
        return this.showMobileMenu;
      }

      return this.isPathActive(item.path);
    },
    async onBottomNavClick(item) {
      if (item.key === "menu") {
        this.showMobileMenu = true;
        return;
      }

      if (!item.path || this.$route.path === item.path) {
        this.showMobileMenu = false;
        return;
      }

      await this.$router.push(item.path).catch((error) => {
        if (error && error.name !== "NavigationDuplicated") {
          throw error;
        }
      });
    },
    isMobileMenuItemActive(item) {
      const itemPath = this.getMobileMenuPath(item);

      if (!itemPath || itemPath === "/logout") {
        return false;
      }

      if (this.isPathActive(itemPath)) {
        return true;
      }

      return item.child?.some((child) => this.isMobileMenuItemActive(child));
    },
    onMobileMenuParentClick(item, index) {
      if (item.child && item.child.length) {
        this.mobileOpenSections[index] = !this.mobileOpenSections[index];
        return;
      }
      this.onMobileMenuSelect(item);
    },
    async onMobileMenuSelect(item) {
      const mappedItem = {
        href: item.link || item.path || item.href || "",
        path: item.path || item.link || item.href || "",
        action: item.action,
      };
      const fakeEvent = { preventDefault: () => {} };
      const shouldClose = await this.handleItemClick(fakeEvent, mappedItem);
      if (shouldClose !== false) {
        this.showMobileMenu = false;
      }
    },
    async handleItemClick(event, item) {
      if (!item) return;

      if (event && typeof event.preventDefault === "function") {
        event.preventDefault();
      }

      if (item.action === "logout" || item.path === "/logout") {
        const result = await Swal.fire({
          title: "Déconnexion",
          text: "Voulez-vous vraiment quitter l'application ?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Oui, me déconnecter",
          cancelButtonText: "Annuler",
          customClass: {
            popup: "swal-popup",
            title: "swal-title",
            confirmButton: "swal-confirm-btn",
            cancelButton: "swal-cancel-btn",
          },
          buttonsStyling: false,
        });

        if (result.isConfirmed) {
          this.$router.push("/logout");
          return true;
        }
        return false;
      }

      if (!item.action) {
        if (item.href && this.$route.path !== item.href) {
          await this.$router.push(item.href).catch((error) => {
            if (error && error.name !== "NavigationDuplicated") {
              throw error;
            }
          });
        }
        return true;
      }

      try {
        let response;
        if (item.action === "addInvoice") response = await addDraftInvoice();
        else if (item.action === "addPurchaseInvoice") response = await addDraftPurchaseInvoice();
        else if (item.action === "addQuote") response = await addDraftOrder();

        if (response?.specialRef) {
          const path =
            item.action === "addInvoice"
              ? "invoice"
              : item.action === "addQuote"
                ? "quote"
                : "purchase/invoice";
          window.location.assign(`/document/generate/${path}/${response.specialRef}`);
        }
        return true;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
  },
};
</script>

<style scoped>
.sidebar-shell {
  
}

.flowbite-sidebar {
  position: fixed;
  inset: 0 auto 0 0;
  width: 264px;
  height: 100vh;
  z-index: 40;
  background:
    radial-gradient(circle at top left, rgba(99, 102, 241, 0.08), transparent 34%),
    linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-right: 1px solid #e2e8f0;
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.08);
  transition: width 180ms cubic-bezier(0.23, 1, 0.32, 1);
}

.flowbite-sidebar.is-collapsed {
  width: 67px;
}

.sidebar-surface {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px 0px 0px;
}

.sidebar-top {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 56px;
  padding: 4px 4px 10px;
}

.sidebar-brand {

  justify-content: center;
  text-align: center;
  width: 100%;

  appearance: none;
  border: 0;
  background: transparent;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  padding: 6px 8px;
  border-radius: 16px;
  color: #0f172a;
  text-align: left;
  cursor: pointer;
  transition: background-color 160ms ease, transform 160ms ease;
}

.sidebar-brand:hover {
  background: rgba(15, 23, 42, 0.04);
}

.sidebar-brand:active,
.sidebar-collapse-btn:active,
.sidebar-item:active,
.mobile-bottom-item:active,
.mobile-menu-item:active {
  transform: translateY(1px) scale(0.98);
}

.sidebar-brand-logo {
  width: 34px;
  height: 34px;
  object-fit: contain;
  border-radius: 10px;
  flex: 0 0 auto;
}

.sidebar-brand-text {
  font-size: 14px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.02em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-collapse-btn {
  width: 34px;
  height: 34px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #ffffff;
  color: #334155;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 160ms ease, background-color 160ms ease, color 160ms ease, transform 160ms ease;
}

.sidebar-collapse-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #111827;
}

.sidebar-nav {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 6px 4px 10px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.sidebar-nav::-webkit-scrollbar {
  width: 6px;
}

.sidebar-nav::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 999px;
}

.sidebar-section-title {
  margin: 18px 10px 8px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #64748b;
  text-align: left;
}

.sidebar-section-title.is-collapsed {
  display: none;
}

.sidebar-group {
  margin-bottom: 6px;
}

.sidebar-item {
  width: 100%;
  appearance: none;
  border: 0;
  background: transparent;
  border-radius: 16px;
  padding: 12px 12px;
  color: #334155;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
  transition:
    background-color 160ms ease,
    color 160ms ease,
    box-shadow 160ms ease,
    transform 160ms ease;
  text-align: left;
}

.sidebar-item:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.sidebar-item.active {
  padding: 7px !important;
  background: rgba(79, 70, 229, 0.08);
  color: #312e81;
  box-shadow: inset 0 0 0 1px rgba(99, 102, 241, 0.18);
}

.sidebar-item-parent.active {
  background: rgba(79, 70, 229, 0.1);
}

.sidebar-item-content {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.sidebar-icon {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  background: #eef2ff;
  color: #4f46e5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.sidebar-item.active .sidebar-icon {
  background: #4f46e5;
  color: #ffffff;
}

.sidebar-icon-child {
  background: #f8fafc;
  color: #475569;
}

.sidebar-label {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-chevron {
  font-size: 11px;
  color: #94a3b8;
  transition: transform 160ms ease, color 160ms ease;
}

.sidebar-item-parent.open .sidebar-chevron {
  color: #4f46e5;
}

.sidebar-submenu {
  margin: 6px 0 10px 16px;
  padding-left: 14px;
  border-left: 1px solid #e2e8f0;
  list-style: none;
}

.sidebar-submenu > li + li {
  margin-top: 6px;
}

.sidebar-item-child {
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 14px;
}

.sidebar-footer {
  padding-top: 12px;
}

.sidebar-footer-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);
}

.sidebar-footer-avatar {
  width: 40px;
  height: 40px;
  border-radius: 14px;
  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 800;
  flex: 0 0 auto;
}

.sidebar-footer-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  text-align: left;
}

.sidebar-footer-text strong {
  font-size: 13px;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-footer-text span {
  font-size: 11px;
  color: #64748b;
}

.sidebar-submenu-enter-active,
.sidebar-submenu-leave-active {
  transition: opacity 160ms ease, transform 160ms ease;
}

.sidebar-submenu-enter-from,
.sidebar-submenu-leave-to {
  opacity: 0;
  transform: translateX(-4px);
}

.mobile-bottom-bar {
  display: none;
}

.mobile-bottom-item {
  border: 0;
  background: transparent;
  color: #1c2741;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  padding: 8px 4px;
  font: inherit;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: -0.2px;
  transition: color 0.2s ease, transform 0.2s ease;
}

.bottom-icon {
  width: 34px;
  height: 28px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  transition: background-color 0.2s ease, color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.bottom-label {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-bottom-item.active {
  color: #1c2741;
}

.mobile-bottom-item.active .bottom-icon {
  background: rgba(28, 39, 65, 0.1);
  color: #4f46e5;
}

.mobile-bottom-item.primary {
  color: #ffffff;
  transform: translateY(4px);
}

.mobile-bottom-item.primary .bottom-icon {
  margin-top: 4px;
  width: 50px;
  height: 50px;
  border-radius: 22px;
  background: linear-gradient(135deg, #4f46e5 0%, #4f46e5 100%);
  color: #ffffff;
  box-shadow: 0 16px 34px rgba(28, 39, 65, 0.36);
  font-size: 20px;
}

.mobile-bottom-item.primary .bottom-label {
  color: #1c2741;
  margin-top: 1px;
}

.mobile-bottom-item.primary.active .bottom-icon {
  box-shadow: 0 18px 40px rgba(28, 39, 65, 0.44);
}

:deep(body.modal-open .mobile-menu-bottom-sheet .modal-dialog) {
  margin: 0;
  max-width: 100%;
  width: 100%;
  position: fixed;
  bottom: calc(92px + env(safe-area-inset-bottom));
  left: 0;
  right: 0;
  transform: none !important;
  animation: sheetTranslateUp 0.28s cubic-bezier(0.16, 1, 0.3, 1);
}

:deep(body.modal-open .mobile-menu-bottom-sheet) {
  padding-left: 0 !important;
}

:deep(body.modal-open .mobile-menu-bottom-sheet .modal-backdrop),
:deep(body.modal-open .modal-backdrop) {
  background-color: #020617;
}

:deep(body.modal-open .mobile-menu-sheet-content) {
  border: none;
  border-radius: 32px 32px 0 0;
  overflow: hidden;
  max-height: calc(100vh - 112px);
  max-height: calc(100dvh - 112px);
  background: #f7f8fa;
  color: #0f172a;
  box-shadow: 0 -20px 60px rgba(15, 23, 42, 0.2);
  transform-origin: bottom center;
}

:deep(body.modal-open .mobile-menu-body) {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  min-height: 0;
  -webkit-overflow-scrolling: touch;
}

.mobile-sheet-handle {
  width: 38px;
  height: 5px;
  margin: 9px auto 1px;
  border-radius: 999px;
  background: #cbd5e1;
  flex: 0 0 auto;
}

.mobile-sheet-intro {
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px 14px;
  background: rgba(247, 248, 250, 0.92);
  backdrop-filter: blur(16px);
}

.mobile-sheet-intro > div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.mobile-sheet-eyebrow {
  color: #64748b;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.mobile-sheet-intro strong {
  color: #0f172a;
  font-size: 24px;
  font-weight: 800;
  line-height: 1.2;
}

.mobile-sheet-close {
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #e8ebef;
  color: #334155;
  cursor: pointer;
  transition: transform 140ms cubic-bezier(0.23, 1, 0.32, 1);
}

.mobile-sheet-close:active {
  transform: scale(0.94);
}

:deep(body.modal-open .mobile-menu-bottom-sheet .mobile-menu-list) {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
  padding: 14px;
  align-items: stretch;
}

.mobile-menu-section-card {
  --section-color: #2563eb;
  --section-soft: #e8f0ff;
  min-width: 0;
  padding: 4px 2px 14px;
}

.mobile-section-heading,
.mobile-group-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 4px 10px;
  text-align: left;
}

.mobile-group-heading > div {
  display: flex;
  flex-direction: column;
}

.mobile-section-heading strong,
.mobile-group-heading strong {
  color: #0f172a;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.2;
}

.mobile-section-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.mobile-menu-group {
  grid-column: 1 / -1;
  padding: 11px;
  border: 0;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.055);
}

.mobile-group-icon {
  width: 30px;
  height: 30px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  background: var(--section-soft);
  color: var(--section-color);
}

.mobile-submenu {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.mobile-menu-header {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #64748b;
  margin: 10px 4px 4px;
}

.mobile-menu-item {
  position: relative;
  width: 100%;
  appearance: none;
  border: 0;
  background: #ffffff;
  border-radius: 20px;
  min-width: 0;
  min-height: 108px;
  padding: 12px 7px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 9px;
  text-align: center;
  color: #0f172a;
  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.055);
  transition: transform 140ms cubic-bezier(0.23, 1, 0.32, 1), background-color 140ms ease, box-shadow 140ms ease;
  cursor: pointer;
}

.mobile-menu-item:active {
  transform: scale(0.97);
}

.mobile-menu-item.active {
  background: #2563eb;
  color: #ffffff;
  box-shadow: 0 10px 24px rgba(37, 99, 235, 0.24);
}

.mobile-item-left {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 0;
  font-size: 11px;
  font-weight: 750;
}

.mobile-item-left > span:last-child {
  width: 100%;
  overflow: hidden;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.mobile-card-icon {
  width: 48px;
  height: 48px;
  border-radius: 17px;
  background: var(--section-soft);
  color: var(--section-color);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.mobile-card-icon-child {
  width: 44px;
  height: 44px;
  border-radius: 15px;
}

.mobile-menu-item.active .mobile-card-icon {
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
}

.mobile-menu-item-parent.open .mobile-card-icon {
  background: #4f46e5;
  color: #ffffff;
}

.mobile-menu-item-child {
  padding: 10px 5px;
  min-height: 102px;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #f5f7fa;
  box-shadow: none;
}

.mobile-menu-item-child .mobile-item-left {
  align-items: center;
}

.mobile-menu-item-child .mobile-card-icon {
  width: 44px;
  height: 44px;
  border-radius: 15px;
}

.mobile-menu-item-child .mobile-item-chevron {
  align-self: flex-end;
}

.mobile-item-chevron {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #94a3b8;
  font-size: 11px;
}

.mobile-apk-download {
  padding: 0 14px 14px;
}

.mobile-apk-download-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  border-radius: 18px;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  color: #ffffff;
  text-decoration: none;
}

.mobile-apk-icon {
  width: 40px;
  height: 40px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.12);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.mobile-apk-download-btn strong,
.mobile-apk-download-btn small {
  display: block;
}

.mobile-apk-download-btn small {
  color: rgba(255, 255, 255, 0.72);
}

@keyframes sheetTranslateUp {
  from {
    transform: translateY(18px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@media (max-width: 767px) {
  .flowbite-sidebar {
    display: none;
  }

  .mobile-bottom-bar {
    position: fixed;
    inset: auto 0 0;
    z-index: 39;
    display: flex;
    align-items: end;
    justify-content: space-between;
    gap: 6px;
    padding: 0px 10px calc(5px + env(safe-area-inset-bottom));
    background: rgba(255, 255, 255, 0.92);
    backdrop-filter: blur(18px);
    border-top: 1px solid rgba(226, 232, 240, 0.9);
    box-shadow: 0 -12px 30px rgba(15, 23, 42, 0.08);
  }

  .mobile-bottom-bar.is-compact {
    justify-content: center;
    gap: 26px;
  }

  .mobile-bottom-item {
    flex: 0 1 76px;
  }
}

@media (max-width: 480px) {
  :deep(body.modal-open .mobile-menu-bottom-sheet .mobile-menu-list) {
    gap: 8px;
    padding: 12px;
  }

  .mobile-submenu {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 420px) {
  .mobile-submenu {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (prefers-reduced-motion: reduce) {
  :deep(body.modal-open .mobile-menu-bottom-sheet .modal-dialog) {
    animation: none;
  }

  .mobile-menu-item,
  .mobile-sheet-close {
    transition-duration: 0.01ms;
  }
}
</style>
